import { PropsWithChildren } from 'react'

import { AutoEnrollmentRepository } from '@/AutoEnrollment/domain'
import {
  IUseProductsContractingController,
  useProductsContractingController,
} from '@/Contract/ui/hooks'
import { createGenericContext } from '@/Shared/ui/createGenericContext'

type Context = {
  autoEnrollmentRepository: AutoEnrollmentRepository
} & IUseProductsContractingController

type Props = PropsWithChildren & {
  autoEnrollmentRepository: AutoEnrollmentRepository
  origin?: string
}

const [useContractNewProducts, StateContextProvider] = createGenericContext<Context>()

const ContractNewProductsProvider = ({
  autoEnrollmentRepository,
  origin,
  children,
}: Props): JSX.Element => {
  const controller = useProductsContractingController(autoEnrollmentRepository, origin)
  return (
    <StateContextProvider value={{ autoEnrollmentRepository, ...controller }}>
      {children}
    </StateContextProvider>
  )
}

export { ContractNewProductsProvider, useContractNewProducts }
